import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {toast} from "react-toastify";

import {newPasswordCredentailsApi} from "../../../services/manage-user/user";
import { addPartnerApi, getPartnerApi, getPartnersApi, getPartnerSettingsApi, showPartnerApi, updatePartnerApi, updatePartnerOrderApi, updatePartnerStatusApi, partnerFormatSelectAutoSuggestionApi, addPartnerInvoiceDataApi, getPartnersInvoiceDataApi, getStatementReconsiliationSettingsApi, getReconciliationDataApi, getReconciliationSummaryApi, getReconciliationDetailsApi, getUnmatchedDataApi, addInvoiceItemDecisionApi, generateStatementReconciliationDetails, getMisMatchedDataApi, generateMismatchDetails, emailSendingStatementReconciliationDetailsApi, generateAllStatementReconciliationDetails } from '../../../services/partner';

export const getPartners = createAsyncThunk('partners/getAllPartners', async (data,{dispatch,}) => {
    const response = await getPartnersApi(data);
    dispatch(setPartnerData(response.response));
    dispatch(setShippingSettingPaginationData(response.response.pagination))
    return response.response;
});

export const getPartner = createAsyncThunk('partners/editPartner', async (id,{dispatch})=>{
    const response = await getPartnerApi(id);
    return response.response;
});

export const showPartner = createAsyncThunk('partners/getPartner', async (id,{dispatch})=>{
    const response = await showPartnerApi(id);
    return response.response;
});

export const addPartner = createAsyncThunk('partners/addPartner', async (partner, { dispatch, getState }) => {
    try {
        const response = await addPartnerApi(partner);
        const data = await response.response;
        // dispatch(getUsers());
        toast.success("Partner added successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });

        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const updatePartnerOrder = createAsyncThunk('partners/updatePartnerOrder', async (data, { dispatch }) => {
	try {
		const response = await updatePartnerOrderApi(data);
        toast.success("Order Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
		return await response.response;
	} catch (e) {
		console.log(e);
		return Promise.reject(e);
	}
});

export const updatePartner = createAsyncThunk('partners/updatePartner', async (data,{dispatch}) => {
    const response = await updatePartnerApi(data.data,data.id);
    toast.success(`Partner updated successfully`, {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const updateStatus = createAsyncThunk('partners/onActiveDeactivate', async (data, { dispatch }) => {
	try {
		const response = await updatePartnerStatusApi(data);

        if (response.response.error) {
            toast.error(response.response.message, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }else{
            toast.success("Status Updated Successfully", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        
		return await response.response;
	} catch (e) {
		console.log(e);
		return Promise.reject(e);
	}
});

export const getPartnerSettings = createAsyncThunk('partner/getPartnerSettings', async (id) => {
    const response = await getPartnerSettingsApi(id);
    return response.response;
});

export const addPartnerInvoiceData = createAsyncThunk('partners/addPartnerInvoiceData', async (data, {rejectWithValue}) => {
    try {
        const response = await addPartnerInvoiceDataApi(data);
        const responseData  = await response.response;

        console.log("response", response)
        console.log("responseData", responseData)

        if (responseData?.original?.success === false || responseData?.success === false) {
            toast.error(responseData.message || responseData?.original?.message || "Something went wrong!");
            return rejectWithValue(responseData);
        }

        if (responseData?.original?.success === true || responseData?.success === true) {
            toast.success(responseData.message || responseData?.original?.message || "Action completed successfully!");
        }
        
        return responseData ;
    } catch (e) {

        toast.error(
            e?.response?.data?.message || "An unexpected error occurred!"
        );

        return rejectWithValue(e);
    }
});

export const getPartnersInvoiceData = createAsyncThunk('partners/getPartnersInvoiceData', async (data,{dispatch,}) => {
    const response = await getPartnersInvoiceDataApi(data);
    dispatch(setTableInvoiceRowCount(response.response.count));
    return response.response;
});

export const getStatementReconsiliationSettings = createAsyncThunk('partner/getStatementReconsiliationSettings', async (id) => {
    const response = await getStatementReconsiliationSettingsApi(id);
    return response.response;
});

export const getStatementReconciliation = createAsyncThunk('partners/getStatementReconciliation', async (data,{dispatch,}) => {
    const response = await getReconciliationDataApi(data);
    dispatch(setStatementReconciliationData(response.response.data));
    dispatch(setTableStatementReconciliationRowCount(response.response.count))
    return response.response;
});

export const getStatementReconsiliationSummary = createAsyncThunk('partner/getStatementReconsiliationSummary', async (data) => {
    const response = await getReconciliationSummaryApi(data);
    return response.response;
});

export const getStatementReconciliationDetails = createAsyncThunk('partners/getStatementReconciliationDetails', async (data,{dispatch,signal }) => {
    try {

        const response = await getReconciliationDetailsApi(data, signal);
        dispatch(setSalesTableRowCount(response.response.sales.pagination.total))
        dispatch(setReturnTableRowCount(response.response.returns.pagination.total))
        dispatch(setSalesTableData(response.response.sales.data))
        dispatch(setReturnTableData(response.response.returns.data))
        return response.response;
        
    } catch (err) {

      if (err.name === 'CanceledError') return;

      throw err;
    }
    
});

export const getUnmatchedData = createAsyncThunk('partners/getUnmatchedData', async (data,{dispatch,}) => {
    const response = await getUnmatchedDataApi(data);
    dispatch(setUnMatchedTableRowCount(response.response.pagination.total))
    dispatch(setUnMatchedTableData(response.response.data))
    return response.response;
});

export const addInvoiceItemDecision = createAsyncThunk('partners/addInvoiceItemDecision', async (partner, { dispatch, getState }) => {
    try {
        const response = await addInvoiceItemDecisionApi(partner);
        return response.response;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const exportStatementReconciliationDetails = createAsyncThunk('order/exportStatementReconciliationDetails', async (data, {dispatch}) => {
    const response = await generateStatementReconciliationDetails(data);

    return response.response;
});


export const getMismatcheddData = createAsyncThunk('partners/getMismatcheddData', async (data,{dispatch,}) => {
    const response = await getMisMatchedDataApi(data);
    dispatch(setMismatchTableRowCount(response.response.pagination.total))
    dispatch(setMisMatchedTableData(response.response.data))
    return response.response;
});

export const exportMismatchnDetails = createAsyncThunk('order/exportMismatchnDetails', async (data, {dispatch}) => {
    const response = await generateMismatchDetails(data);

    return response.response;
});

export const emailSendingStatementReconciliationDetails = createAsyncThunk(
  "order/emailSendingStatementReconciliationDetails",
  async (data, { dispatch }) => {
    try {
      const response = await emailSendingStatementReconciliationDetailsApi(data);
      const res = response.response;

      if (res.success) {
        toast.success(res.message);
      } else {
        toast.error(res.message || "Something went wrong");
      }

      return res;
    } catch (error) {
      toast.error(error.message || "Something went wrong");

      return;
    }
  }
);

export const exportAllStatementReconciliationDetails = createAsyncThunk('order/exportAllStatementReconciliationDetails', async (data, {dispatch}) => {
    const response = await generateAllStatementReconciliationDetails(data);

    return response.response;
});

const partnersAdapter = createEntityAdapter({});

export const { selectAll: selectPartner, selectById: selectPartnerById } = partnersAdapter.getSelectors(
    state => state.partner.partner
);

const partnerSlice = createSlice({
    name: 'partners',
    initialState: partnersAdapter.getInitialState({
        id:null,
        partnerTableRow:0,
        partnerInvoiceTableRow:0,
        statementReconciliaitionTableRow:0,
        salesTableRow:0,
        returnTableRow:0,
        unMatchedTableRow:0,
        misMatchedTableRow:0,
        searchText: '',
        settings:{
          countries:[],
          formats:[],
          channelId:[],
            users:[],
            durations:[],
            shipping_by:[],
            return_costs:[],
            order_receives:[],
            order_conditions:[],
            manuals:[],
            channels:[],
            automatic_app:[],
            intervals:[],
        },
        data:null,
        commissionData:null,
        partnerInvoiceData:null,
        status:'',
        pageCount: 0,
        reconciliationSettings: {
            users:[],
            status:[],
            partners:[],
            approveReasons:[],
            declineReasons:[],
        },
        statementReconciliationData : [],
        appDecDialog: {
            component: 'AddDecWindow',
            type: 'new',
            props: {
                isOpen: false
            },
            data: null,
            isApprove : null
        },
        statementReconciliationSummary : {
            marketplaceName : '',
            fileImportedBy : '',
            importedFile : '',
            startDate : '',
            endDate : '',
            totalMarketPlaceRecords : 0,
            totalExcelFileRecords : 0,
            skuMismatchRecords : 0,
            priceMismatchRecords : 0,
            quantityMismatchRecords : 0,
            refundStatusMismatchRecords : 0,
            orderNotFounds : 0,
            missingOrders : 0,

        },
        salesData : [],
        returnData : [],
        unMatchedData : [],
        misMatchedData : [],
        summaryDialog: {
            title: '',
            props: {
                isOpen: false,
            },
        }
    }),
    reducers: {
        setTableRowCount: (state, action) => {
            state.partnerTableRow = action.payload;
        },
        setTableInvoiceRowCount: (state, action) => {
            state.partnerInvoiceTableRow = action.payload;
        },
        setTableDataCommission: (state, action) => {
            state.commissionData = action.payload;
        },
        setSettings: (state, action) => {
            state.settings = action.payload.settings;
            state.id = action.payload.id
        },
        setPartnerData: (state, action) => {
			state.partnerData = action.payload;
		},
        setShippingSettingPaginationData: (state, action) => {
            state.pageCount = action.payload.count
        },
        setStatusVal: (state, action) => {
            state.status = action.payload
        },
        editDialog: (state, action) => {
			state.dialog = {
				component: 'Schedule',
				type: 'new',
				props: {
					open: true,
					maxWidth: 'md'
				},
				data: null
			};
        },
        setReconciliationVal: (state, action) => {
            state.reconciliationSettings.users = action.payload.users
            state.reconciliationSettings.status = action.payload.status
            state.reconciliationSettings.partners = action.payload.partner
            state.reconciliationSettings.approveReasons = action.payload.approve_reasons
            state.reconciliationSettings.declineReasons = action.payload.decline_reasons
        },
        setStatementReconciliationData: (state, action) => {
            state.statementReconciliationData = action.payload
        },
        setTableStatementReconciliationRowCount: (state, action) => {
            state.statementReconciliaitionTableRow = action.payload
        },
        openAppDecDialog: (state, action) => {
            state.appDecDialog = {
                type: 'new',
                props: {
                    isOpen: true
                },
                data: action.payload,
                isApprove : action.payload.isApprove
            };
        },
        closeAppDecDialog: (state, action) => {
            state.appDecDialog = {
                type: 'new',
                props: {
                    isOpen: false
                },
                data: null,
                isApprove : null
            };
        },
        setStatementReconciliationSummary :(state, action) => {
            state.statementReconciliationSummary.marketplaceName = action.payload.market_place_name;
            state.statementReconciliationSummary.fileImportedBy = action.payload.file_imported_by;
            state.statementReconciliationSummary.importedFile = action.payload.imported_file;
            state.statementReconciliationSummary.startDate = action.payload.start_date;
            state.statementReconciliationSummary.endDate = action.payload.end_date;
            state.statementReconciliationSummary.totalMarketPlaceRecords = action.payload.total_market_place_records;
            state.statementReconciliationSummary.totalExcelFileRecords = action.payload.total_excel_file_records;
            state.statementReconciliationSummary.skuMismatchRecords = action.payload.sku_mismatch_records;
            state.statementReconciliationSummary.priceMismatchRecords = action.payload.price_mismatch_records;
            state.statementReconciliationSummary.quantityMismatchRecords = action.payload.quantity_mismatch_records;
            state.statementReconciliationSummary.refundStatusMismatchRecords = action.payload.refund_status_mismatch_records;
            state.statementReconciliationSummary.orderNotFounds = action.payload.order_not_found_records;
            state.statementReconciliationSummary.missingOrders = action.payload.missing_orders_records;
        },
        setSalesTableRowCount: (state, action) => {
            state.salesTableRow = action.payload
        },
        setSalesTableData: (state, action) => {
            state.salesData = action.payload
        },
        setReturnTableRowCount: (state, action) => {
            state.returnTableRow = action.payload
        },
        setReturnTableData: (state, action) => {
            state.returnData = action.payload
        },
        setUnMatchedTableRowCount: (state, action) => {
            state.unMatchedTableRow = action.payload
        },
        setUnMatchedTableData: (state, action) => {
            state.unMatchedData = action.payload
        },
        setMismatchTableRowCount: (state, action) => {
            state.misMatchedTableRow = action.payload
        },
        setMisMatchedTableData: (state, action) => {
            state.misMatchedData = action.payload
        },
        summaryDialog: (state, action) => {
            state.summaryDialog = action.payload;
        },
    },
    extraReducers: {
        [getPartners.fulfilled]: partnersAdapter.setAll,
        // [updateStaff.fulfilled]: staffsAdapter.setAll
        // [deleteStaff.fulfilled]: staffsAdapter.removeOne,
    }
});

export const {
    setTableRowCount, setTableDataCommission, setSettings, setPartnerData, editDialog, setShippingSettingPaginationData, 
    setStatusVal,setTableInvoiceRowCount, setReconciliationVal, setStatementReconciliationData ,setTableStatementReconciliationRowCount, 
    openAppDecDialog,closeAppDecDialog, setStatementReconciliationSummary, setSalesTableRowCount, setReturnTableRowCount, setSalesTableData, 
    setReturnTableData, setUnMatchedTableData,setUnMatchedTableRowCount, setMismatchTableRowCount, setMisMatchedTableData, summaryDialog
} = partnerSlice.actions;

export default partnerSlice.reducer;
